export { default } from './fx-forwards-position';
